import React, { useEffect, useRef } from 'react'
import * as blueprint from '@adc/blueprint'
// @ts-ignore no types
import { Term } from '@adc/ui-adc'
import { useListingContext } from 'common/context/listing'
import classnames from 'classnames/bind'
// @ts-ignore no types
import ExpandableComponent, {
  useIsVerticalOverflow,
} from 'common/components/expandable'
import { BadgeViewType, mapBadgesToView } from 'common/utils/badges'
import { isForeclosure } from 'common/utils/listing'
import cls from './styles.scss'

const cx = classnames.bind(cls)

const CONTENT_HEIGHT = 18

const BadgeContent = ({
  content,
  setShowOverlay,
}: {
  content: string | JSX.Element
  setShowOverlay: (isOverflow: boolean) => void
}) => {
  const cardRef = useRef<HTMLDivElement>(null)
  const isOverflow = useIsVerticalOverflow(cardRef, CONTENT_HEIGHT)

  useEffect(() => {
    setShowOverlay(isOverflow)
  }, [isOverflow, setShowOverlay])

  return (
    <div ref={cardRef} className={cx('badge-term-content')}>
      {content}
    </div>
  )
}

const TermBadge = ({
  badge,
  setShowOverlay,
  isExpanded,
}: {
  badge: BadgeViewType
  setShowOverlay: (isOverflow: boolean) => void
  isExpanded: boolean
}) => {
  return (
    <div className={cx('term-container')}>
      <Term
        iconName={badge.icon}
        label={String(badge.title)}
        // @ts-ignore element is valid type here, TODO update DS types
        value={
          <BadgeContent
            content={badge.content}
            setShowOverlay={setShowOverlay}
          />
        }
        withCardContainer
        tooltipContent={badge.tooltipContent}
        isExpanded={isExpanded}
      />
    </div>
  )
}

const SaleTermBadges = () => {
  const { listing, segment } = useListingContext()
  const badgeList = blueprint.listing.utils.calculatePDPSellerTermsBadges(
    listing,
    segment !== null ? segment : undefined
  )
  const badgesWithContent = mapBadgesToView(badgeList, listing, () => {})
  const isListingForeclosure = isForeclosure(listing)

  return (
    <div className={cx('term-list')}>
      {badgesWithContent.map((badge, index) => (
        <div
          key={index}
          className={cx('term-list-item', {
            'full-width':
              isListingForeclosure || (!index && badgeList.length % 2 !== 0),
          })}
        >
          <ExpandableComponent badge={badge} component={TermBadge} />
        </div>
      ))}
    </div>
  )
}

export default SaleTermBadges
